
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "noticedetail",
components: {
XHeader
},
data(){
return{
notice:{
title:'西京学院2019年收费标准',
date:'2019-07-20',
author:'招生就业办公室',
depart:'招生就业办公室',
content0: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;祝贺您成为西京学院的新同学，全院师生员工欢迎您的到来。为方便您顺利报到，请仔细阅读了解以下事项，做好入学准备。',

}
}
}
}



// WEBPACK FOOTER //
// ./src/components/feeMenu.vue